import {
  type BadgeTone,
  badgeToneClass,
} from "components/ui/StatusBadge/StatusBadge";
import type { DeliverySeriesStatus } from "hooks/use-delivery-series-api";
import type { FC } from "react";

const TONE: Record<DeliverySeriesStatus, BadgeTone> = {
  active: "soft-success",
  archived: "soft-neutral",
};

const LABEL: Record<DeliverySeriesStatus, string> = {
  active: "active",
  archived: "archived",
};

export type DeliverySeriesStatusBadgeProps = {
  status: DeliverySeriesStatus;
};

/**
 * シリーズステータス (active / archived) を StatusBadge と整合させて表示する.
 * @param {DeliverySeriesStatusBadgeProps} props ステータス
 * @return {JSX.Element} バッジ
 */
export const DeliverySeriesStatusBadge: FC<DeliverySeriesStatusBadgeProps> = ({
  status,
}) => {
  return <span className={badgeToneClass[TONE[status]]}>{LABEL[status]}</span>;
};
